import EventUtils from '@/utils/EventUtils.js';
import UserEvents from '@/domain/model/user/UserEvents.js';

const state = {
    event: {},
    signUpEvent: {},
    verifyEvent: {},
};

const getters = {
    register_event : state => state.event,
    register_signUpEvent : state => state.signUpEvent,
    register_verifyEvent : state => state.verifyEvent,
};

const actions = {
};

const mutations = {
  SOCKET_ONMESSAGE (state, event)  {
    if (event && event.status == EventUtils.STATUS.COMPLETE &&
        event.eventName == UserEvents.SignUp.Names.Response) {
      state.signUpEvent = event;
    }
    if (event && event.status == EventUtils.STATUS.COMPLETE &&
        event.eventName == UserEvents.Verify.Names.Response) {
      state.verifyEvent = event;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
